<template>
    <b-modal
      id="splitLevelsModal"
      ref="splitLevelsModal"
      hide-footer
      title="Split Levels"
      centered
    >
      <div class="text-center py-3">
        <p>
          You have <strong>{{ totalQuestions }}</strong> questions.<br />
          Would you like to split them into <strong>{{ totalLevels }}</strong> levels?
        </p>
  
        <b-button variant="primary" class="mt-3" @click="confirmSplit">
          Save
        </b-button>
      </div>
  
      <!-- Confirmation Dialog -->
      <b-modal
        id="confirmSplitModal"
        title="Are you sure?"
        @ok="performSplit"
        ok-title="Yes, do it"
        cancel-title="Cancel"
      >
        This will move questions and create new levels.
      </b-modal>
      <!-- <b-modal
  id="confirmSplitModal"
  hide-footer
  centered
  size="md"
  title=""
>
  <div class="text-center py-4">
    <div style="font-size: 48px; color: #f0ad4e;">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
    </div>

    <h4 class="my-3 font-weight-bold">Are you sure?</h4>
    <p>Do you want to change the plugin?</p>

    <b-button variant="primary" class="mr-2" @click="performSplit">
      Yes, Save it!
    </b-button>
    <b-button variant="secondary" @click="$bvModal.hide('confirmSplitModal')">
      Cancel
    </b-button>
  </div>
</b-modal> -->

    </b-modal>
  </template>
  
  <script>
  import { BButton, BModal } from "bootstrap-vue";
  import Swal from "sweetalert2";
  import axios from "axios";
  
  export default {
    name: "MoveQuestionsLevelsModal",
    components: {
      BButton,
      BModal,
    },
    props: {
      groupedQuestions: {
        type: Array,
        required: true,
      },
      categoryId: {
        type: [String, Number],
        required: true,
      },
    },
    data() {
      return {
        totalQuestions: 0,
        totalLevels: 0,
        maxLevelNumber: 0,
      };
    },
    watch: {
      groupedQuestions: {
        immediate: true,
        handler(newVal) {
          if (Array.isArray(newVal)) {
            this.totalLevels = newVal.length;
            this.totalQuestions = newVal.reduce((sum, group) => sum + group.length, 0);
          }
        },
      },
    },
  
    methods: {
      open() {
        this.$refs.splitLevelsModal.show();
      },
      async confirmSplit() {
        this.maxLevelNumber = await this.getMaxLevelNumber();
        //   this.$bvModal.show("confirmSplitModal");
        Swal.fire({
            title: "Are you sure?",
            text: "This will move questions and create new levels.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Save it!",
        }).then((result) => {
            if (result.isConfirmed) {
            this.performSplit();
            }
        });
        },
      async getMaxLevelNumber() {
  try {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/splitlevel/${this.categoryId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("_t"),
      },
    });

    const levels = response.data.level;
    const levelNumbers = levels
      .map(lvl => parseInt(lvl.levelName))
      .filter(num => !isNaN(num)); 

    const maxLevelNumber = levelNumbers.length ? Math.max(...levelNumbers) : 1;
    return maxLevelNumber;
  } catch (error) {
    console.error("Failed to fetch levels:", error);
    return 1;
  }
},
async performSplit() {
  try {
    const maxLevel = await this.getMaxLevelNumber();
    // console.log("Starting from level:", maxLevel + 1);

    const groups = [];

    for (let i = 0; i < this.groupedQuestions.length; i++) {
      const group = this.groupedQuestions[i];
      const level_name = maxLevel + i + 1;

      groups.push({
        level_name,
        questionIds: group.map((q) => q._id),
      });
    }

    const res = await axios.post(`${process.env.VUE_APP_API_URL}/level/split-questions`, {
      groups: groups,
      sub_category_id: this.categoryId,
    }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("_t"),
      },
    });

    // console.log("Response:", res.data);

    Swal.fire("Success", "Questions successfully split into new levels.", "success");
    this.$emit("refreshData");
    this.$refs.splitLevelsModal.hide();

  } catch (error) {
    console.error("Error:", error);
    Swal.fire("Error", "Something went wrong during split.", "error");
  }
},



    //   async performSplit() {
    //     try {
    //       for (let i = 0; i < this.groupedQuestions.length; i++) {
    //         const group = this.groupedQuestions[i];
  
    //         // 1. Create new level
    //         const levelRes = await axios.post(`${process.env.VUE_APP_API_URL}/level`, {
    //           levelName: `Auto Level ${i + 1}`,
    //           sub_category_id: this.categoryId,
    //           NoofQuestion: group.length,
    //           selectStatus: "inactive",
    //         }, {
    //           headers: {
    //             Authorization: "Bearer " + localStorage.getItem("_t"),
    //           },
    //         });
  
    //         const newLevel = levelRes.data.level || levelRes.data;
  
    //         const questionIds = group.map((q) => q._id);
  
    //         await axios.post(`${process.env.VUE_APP_API_URL}/level/move-questions`, {
    //           questionIds: questionIds,
    //           levelId: newLevel._id || newLevel.id,
    //         }, {
    //           headers: {
    //             Authorization: "Bearer " + localStorage.getItem("_t"),
    //           },
    //         });
    //       }
  
    //       Swal.fire("Success", "Questions successfully split into new levels.", "success");
    //       this.$emit("refreshData");
    //       this.$refs.splitLevelsModal.hide();
    //     } catch (error) {
    //       console.error(error);
    //       Swal.fire("Error", "Something went wrong during split.", "error");
    //     }
    //   },
    },
  };
  </script>
  
  <style scoped>
  .text-center {
    text-align: center;
  }
  </style>
  